import { render, staticRenderFns } from "./citizen.vue?vue&type=template&id=427d0cae&"
import script from "./citizen.vue?vue&type=script&lang=ts&"
export * from "./citizen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports